import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router'
import { useTranslation } from '@/i18n'

export const HomePage = () => {
  const { t } = useTranslation()

  const [currentTime, setCurrentTime] = useState('')

  const getCurrentTime = useCallback(() => {
    const now = new Date()
    return now
      .toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })
      .replace(/\//g, '-')
  }, [])

  useEffect(() => {
    const updateTime = () => setCurrentTime(getCurrentTime())
    updateTime()

    const timeInterval = setInterval(updateTime, 1000)

    return () => clearInterval(timeInterval)
  }, [getCurrentTime])

  return (
    <div className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center'>
      <div className='text-center space-y-6 p-8 bg-white dark:bg-gray-800 rounded-xl shadow-lg'>
        <h1 className='text-4xl font-bold text-gray-800 dark:text-white font-mono'>{currentTime}</h1>
        <p className='text-gray-600 dark:text-gray-300'>{t('pages:home.title')}</p>
        <Link
          to='/about'
          className='inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200'
        >
          {t('pages:home.goToAbout')}
        </Link>
      </div>
    </div>
  )
}
